import Feature from '@/domain/feature/entity/feature.entity';
import Justify from '@/domain/justify/domain/justify.entity';
import ReasonsCancellation from '@/domain/justify/domain/reasons-cancellation.entity';
import DateFormat from '@/shared/utils/date-format';

export default class ContractCancellationRequest {
  expiresAt: string;

  expiresSolicitation: string;

  markedToExpire: boolean;

  exemptFine: boolean;

  exemptFineApprover: string;

  exemptFineValue: any;

  exemptContractualTerm: boolean;

  expirationObservation: string;

  billLastInvoice: boolean | null;

  features: Feature[];

  justification: Justify;

  reasonsCancellation?: ReasonsCancellation;

  descriptionsJustifications: string;

  churnResponsible: string;

  constructor(obj: any = {}) {
    this.expiresAt = obj.expiresAt || '';
    this.expiresSolicitation = obj.expiresSolicitation || '';
    this.markedToExpire = obj.markedToExpire || false;
    this.exemptFine = obj.exemptFine || false;
    this.exemptFineApprover = obj.exemptFineApprover || '';
    this.exemptFineValue = obj.exemptFineValue || 0;
    this.exemptContractualTerm = obj.exemptContractualTerm || false;
    this.expirationObservation = obj.expirationObservation || '';
    this.billLastInvoice = obj.billLastInvoice ?? null;
    this.features = obj.features || [];
    this.justification = obj.justification || null;
    this.reasonsCancellation = obj.reasonsCancellation
      ? ReasonsCancellation.of(obj.reasonsCancellation)
      : undefined;
    this.descriptionsJustifications = obj.descriptionsJustifications || '';
    this.churnResponsible = obj.churnResponsible || '';
  }

  public static of(obj: any): ContractCancellationRequest {
    return new ContractCancellationRequest(obj || {});
  }

  public static ofList(obj: any[]): ContractCancellationRequest[] {
    return obj.map(this.of);
  }

  get expiresSolicitationFormatted(): string {
    return DateFormat.timestampToLocal(this.expiresSolicitation);
  }

  get expiresAtFormatted(): string {
    return DateFormat.timestampToLocal(this.expiresAt);
  }
}
